/**
 * Mobile menu tools.
 */
H_Tools.mobilemenu = (() => {
    // console.log('Mobile menu tools initialized...');
    let doc = document.documentElement;

    /**
     * Opens the menu.
     *
     * @param {*} toggles
     */
    function openMenu(toggles) {
        for (let i = 0; i < toggles.length; i++) {
            toggles[i].setAttribute('aria-expanded', 'true');
        }
        doc.classList.add('-is-active-menu');
    }

    /**
     * Closes the menu.
     *
     * @param {*} menu
     * @param {*} toggles
     * @param {*} animationDuration
     * @param {*} toggle            (Optional) The toggle that triggered the close
     */
    function closeMenu(menu, toggles, animationDuration = 200, toggle = false) {
        // console.log('Closing menu...');
        // console.log('toggle', toggle);

        for (let i = 0; i < toggles.length; i++) {
            toggles[i].setAttribute('aria-expanded', 'false');
        }

        if (
            toggle &&
            'classList' in toggle &&
            toggle.classList.contains('js-mobile-menu-toggle') &&
            !toggle.classList.contains('-can-open')
        ) {
            H_Tools.mobilemenu.focusOpeningToggle(menu);
        }

        doc.classList.add('-is-closing-menu');
        setTimeout(() => {
            doc.classList.remove('-is-active-menu');
            doc.classList.remove('-is-closing-menu');
        }, animationDuration);
    }

    /**
     * Makes all focusable children of the supplied element close the mobile menu
     * on focus, provided that they aren't a mobile menu toggle or inside the mobile menu.
     *
     * This function may need to be reaplied if the DOM is manipulated using JavaScript.
     *
     * @param {*} menu
     * @param {*} toggles
     * @param {*} el                An element whose focusable children should close the mobile menu
     * @param {*} animationDuration (Optional)
     */
    function makeOutsideFocusCloseMenu(
        menu,
        toggles,
        el,
        animationDuration = 200
    ) {
        H_Tools.focus.getFocusableChildren(el).forEach((element) => {
            // focusing mobile menu toggles should not close the mobile menu
            if (element.classList.contains('js-mobile-menu-toggle')) {
                return;
            }

            // focusing elements inside the mobile menu should not close the mobile menu
            if (menu.contains(element)) {
                return;
            }

            element.addEventListener('focus', (e) => {
                if (!doc.classList.contains('-is-active-menu')) {
                    return;
                }
                closeMenu(menu, toggles, animationDuration);
            });
        });
    }

    /**
     * Attempts to find the toggle that opened the mobile menu; if found, shifts focus to that toggle.
     *
     * @param {*} menu
     */
    function focusOpeningToggle(menu) {
        // console.log('Attempting to focus a toggle that opened the menu...');

        let opener = menu.parentNode.querySelector(
            '.js-mobile-menu-toggle.-can-open'
        );
        if (!opener) {
            return;
        }
        opener.focus();
    }

    // Return an object to expose inner functions
    return {
        makeOutsideFocusCloseMenu: makeOutsideFocusCloseMenu,
        focusOpeningToggle: focusOpeningToggle,
        openMenu: openMenu,
        closeMenu: closeMenu,
    };
})();
